module.exports = __webpack_public_path__ + "static/img/ax.1345aec8.svg";